/**
 * One row in "A mai napod". Completed trips grey out and strike through the
 * time; the next one keeps the amber border so the driver's eye lands on it.
 */
import React from 'react';
import { formatTime } from '../../../Utils/timezone';
import {
  formatHours, hasProgramme, isFinished, place, programmeHours, totalPassengers,
} from '../portalFormat';
import { CheckIcon, ChevronRightIcon } from './Icons';

const metaFor = (trip) => {
  const parts = [];
  const people = totalPassengers(trip);
  if (people) parts.push(`${people} utas`);
  if (hasProgramme(trip)) {
    const hours = programmeHours(trip);
    parts.push(hours ? `program, ${formatHours(hours)} óra` : 'program');
  }
  if (trip.flight_number) parts.push(trip.flight_number);
  return parts.join(' · ');
};

export default function TripRow({ trip, isNext = false, onOpen }) {
  const done = isFinished(trip);
  const from = place(trip.from).title;
  const to = place(trip.to).title;
  const route = [from, to].filter(Boolean).join(' → ') || 'Útvonal egyeztetés alatt';
  const meta = metaFor(trip);

  const classes = ['pp-trip'];
  if (isNext) classes.push('pp-trip--next');
  if (done) classes.push('pp-trip--done');

  return (
    <button
      type="button"
      className={classes.join(' ')}
      onClick={() => onOpen(trip)}
    >
      <span className="pp-trip__time">{formatTime(trip.date_datetime)}</span>
      <span className="pp-trip__body">
        <span className="pp-trip__route">{route}</span>
        {meta ? <span className="pp-trip__meta">{meta}</span> : null}
      </span>
      {done && <CheckIcon className="pp-trip__done" size={20} width={2.5} />}
      {!done && isNext && <span className="pp-trip__flag">Következő</span>}
      {!done && !isNext && <ChevronRightIcon className="pp-trip__chevron" size={18} />}
    </button>
  );
}
